import Phaser from "phaser";
import { integerGameViewSize } from "./game/constants";
import { gameConfig } from "./game/config";

const container = document.getElementById("game-container");

function snapGameView(): void {
  if (!container) {
    return;
  }
  const { width, height } = integerGameViewSize(window.innerWidth, window.innerHeight);
  container.style.width = `${width}px`;
  container.style.height = `${height}px`;
}

snapGameView();
window.addEventListener("resize", snapGameView);
window.visualViewport?.addEventListener("resize", snapGameView);

container?.focus();
new Phaser.Game(gameConfig);

const canvas = container?.querySelector("canvas");
if (canvas instanceof HTMLCanvasElement) {
  canvas.tabIndex = 0;
  container?.addEventListener("pointerdown", () => {
    canvas.focus({ preventScroll: true });
  });
}
